var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5263",
    d: "M8.715 0C3.91 0 0 3.258 0 7.262a6.334 6.334 0 0 0 1.359 3.892L.039 13.9a.4.4 0 0 0 .121.49.6.6 0 0 0 .385.133.646.646 0 0 0 .2-.033l3.3-1.1a9.908 9.908 0 0 0 4.671 1.133c4.8 0 8.715-3.258 8.715-7.262S13.52 0 8.715 0zm0 13.616a8.607 8.607 0 0 1-4.3-1.108.617.617 0 0 0-.309-.081.641.641 0 0 0-.2.033l-2.381.8.954-1.984a.392.392 0 0 0-.058-.427 5.566 5.566 0 0 1-1.33-3.582c0-3.5 3.42-6.354 7.625-6.354s7.625 2.85 7.625 6.354-3.422 6.349-7.626 6.349z",
    transform: "translate(1.453 2.571)",
    style: {
      fill: "#444",
      stroke: "#444",
      strokeWidth: ".6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChat);
export default __webpack_public_path__ + "static/media/ic-chat.5eec255b8cab8e6a945d096f7143bbc3.svg";
export { ForwardRef as ReactComponent };